import { useEffect, useRef } from 'react';

const HubSpotForm = () => {
    const formRef = useRef(null);

    useEffect(() => {
        const loadForm = () => {
            if (window.hbspt && formRef.current) {
                window.hbspt.forms.create({
                    portalId: '287495', // Replace with your HubSpot portal ID
                    formId: 'f2aa8f07-05e7-486f-82a4-6148c3b569fb',     // Replace with your HubSpot form ID
                    target: '#hubspotForm'
                });
            }
        };

        // Ensure the HubSpot script is loaded
        if (window.hbspt) {
            loadForm();
        } else {
            const interval = setInterval(() => {
                if (window.hbspt) {
                    clearInterval(interval);
                    loadForm();
                }
            }, 100);
        }
    }, []);

    return <div id="hubspotForm" ref={formRef}></div>;
};

export default HubSpotForm;
